import React, { Component } from 'react';
import { Row, Col, Button, Form, Input, DatePicker, Radio, TimePicker } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import SearchBar from './SearchBar'
import MapLoader from './MapLoader';


class PostRequestForm extends Component {
 
  render() {
      const { getFieldDecorator } = this.props.form;
      const { TextArea } = Input;

    return (
        <div>
            {/* <MainHeader/> */}
            <div style={{ background: '#ff3d00'}}>
                <Row>
                    <Col md={{span: 24}}>
                        <h1 style={{color: "#ffffff", margin: "12px", textAlign: 'center', fontWeight: 'bold'}}>Post a request</h1>
                    </Col>
                </Row>
            </div>
            <div style={{ padding: 24}}>
                <br/>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col md={{span:8, offset:4}}>
                            {/* <Form.Item
                                label="Coming From:"
                                // labelCol={{ span: 5 }}
                                // wrapperCol={{ span: 12 }}
                                >
                                {getFieldDecorator('comingFrom', {
                                    rules: [{ required: true, message: 'Please enter where you will be coming from.' }],
                                })(
                                    <Input style={{ height: '3em' }}  placeholder="Enter where you will be coming from." />
                                )}
                            </Form.Item> */}
                            <h4 style={{fontWeight: 'normal'}}>Coming From:</h4>
                            <SearchBar />

                            <br/>
                            <h4 style={{fontWeight: 'normal'}}>Going To:</h4>
                            <SearchBar />
                            <br/>    
                            {/* <Form.Item
                                label="Going To:"
                                // labelCol={{ span: 5 }}
                                // wrapperCol={{ span: 12 }}
                                >
                                {getFieldDecorator('goingTo', {
                                    rules: [{ required: true, message: 'Please enter your destination.' }],
                                })(
                                    <Input style={{ height: '3em' }}  placeholder="Enter your destination" />
                                )}
                            </Form.Item> */}
                            <Form.Item
                                // {...formItemLayout}
                                label="When are you Leaving ?"
                                style={{ display: 'inline-block'}}
                                >
                                {getFieldDecorator('date-picker', 
                                {
                                    rules: [{ type: 'object', required: true, message: 'Please select date!' }],
                                })(
                                    <DatePicker  />
                                )}
                            </Form.Item>
                            <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>
                              &nbsp;
                            </span>
                            <Form.Item
                                // {...formItemLayout}
                                label="Time"
                                style={{ display: 'inline-block'}}
                                >
                                {getFieldDecorator('time-picker', {
                                    rules: [{ type: 'object', required: false }],
                                })(
                                    <TimePicker />
                                )}
                            </Form.Item>
                            <Form.Item
                                label="How many seats do you need?"
                                // {...formItemLayout}
                            >
                                <Radio.Group defaultValue="1" onChange={this.handleFormLayoutChange}>
                                <Radio.Button value="1">1</Radio.Button>
                                <Radio.Button value="2">2</Radio.Button>
                                <Radio.Button value="3">3</Radio.Button>
                                <Radio.Button value="4">4</Radio.Button>
                                <Radio.Button value="5">5</Radio.Button>
                                <Radio.Button value="6">6</Radio.Button>
                                <Radio.Button value="7">7</Radio.Button>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                label="Describe your trip:"
                                // labelCol={{ span: 5 }}
                                // wrapperCol={{ span: 12 }}
                                >
                                {getFieldDecorator('description', {
                                    rules: [{ required: true, message: 'Please enter some description about your trip' }],
                                })(
                                    <TextArea rows={4}  placeholder="Tell drivers about your ride" />
                                )}
                            </Form.Item>
                            <Form.Item
                                // wrapperCol={{ span: 12, offset: 5 }}
                                >
                                <Button type="primary" htmlType="submit" style={{height: '3em', marginRight: '10px', width: '100%', backgroundColor: '#ff3d00', borderWidth: '0px'}}>
                                    Post Request
                                </Button>
                            </Form.Item>
                        </Col>
                        
                        <Col md={{span:8, offset:1}}>
                            {/* <Map google={this.props.google} zoom={14} style={{height: '30vw'}}>
    
                                <Marker onClick={this.onMarkerClick}
                                        name={'Current location'} />
                        
                                <InfoWindow onClose={this.onInfoWindowClose}>
                                    <div>
                                    <h1>{this.state.selectedPlace.name}</h1>
                                    </div>
                                </InfoWindow>
                            </Map> */}
                            <MapLoader/>
                        </Col>
                    </Row>
                    
                    
                    
            </Form>
            </div> 
        </div>
    );
  }
}

const PostRequest = Form.create({ name: 'post-request-form' })(PostRequestForm);
// export default PostTripForm;
export default PostRequest;
// GoogleApiWrapper({
//     apiKey: ('AIzaSyCZ-lrgcyu8rNUArDpZuWSEPVoLBBNt2zE')
//   })(PostRequest)

